import { render, staticRenderFns } from "./GroupsBlock.vue?vue&type=template&id=3a5f1f85&scoped=true&"
import script from "./GroupsBlock.vue?vue&type=script&lang=ts&"
export * from "./GroupsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsBlock.vue?vue&type=style&index=0&id=3a5f1f85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f1f85",
  null
  
)

export default component.exports